import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "includes" })
export class IncludesPipe implements PipeTransform {
  transform(element: any[] | string, el: any, field?: any): boolean {
    if (element === null || element === undefined) {
      return false;
    }
    if (field) {
      return (element as any[]).map((e) => e[field]).includes(el[field]);
    }
    return element.includes(el);
  }
}
